/* global google */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import turf from '@turf/turf';

import {withMap} from './utils';

const world = turf.polygon([[
  [0, 90],
  [180, 90],
  [180, -90],
  [0, -90],
  [-180, -90],
  [-180, 0],
  [-180, 90],
  [0, 90],
]]);

class Geometry extends React.Component {
  static displayName = 'Geometry';

  static propTypes = {
    map: PropTypes.object.isRequired,
    geoJson: PropTypes.array,
    invert: PropTypes.bool,
    cursor: PropTypes.string,
    fillColor: PropTypes.string,
    fillOpacity: PropTypes.number,
    strokeOpacity: PropTypes.number,
    strokeWeight: PropTypes.number,
    strokeColor: PropTypes.string,
  };

  componentDidMount() {
    this._addFeature();
    this._updateStyle();
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.geoJson, this.props.geoJson)
        || prevProps.invert !== this.props.invert) {
      this._removeFeature();
      this._addFeature();
    }
    this._updateStyle();
  }

  componentWillUnmount() {
    this._removeFeature();
  }

  _addFeature = () => {
    let feature = null;
    if (this.props.geoJson && this.props.geoJson.length) {
      const features = _.map(this.props.geoJson, (geometry) => (turf.feature(geometry)));
      feature = turf.union(...features);
    } else {
      feature = turf.feature({type: 'Polygon', coordinates: [[]]});
    }

    if (this.props.invert) {
      feature = turf.difference(world, feature);
    }
    this._feature = this.props.map.data.addGeoJson(feature)[0];
  };

  _removeFeature = () => {
    this.props.map.data.remove(this._feature);
  };

  _updateStyle = () => {
    this.props.map.data.overrideStyle(this._feature, {
      fillColor: this.props.fillColor,
      fillOpacity: this.props.fillOpacity,
      strokeOpacity: this.props.strokeOpacity,
      strokeWeight: this.props.strokeWeight,
      strokeColor: this.props.strokeColor,
      cursor: this.props.cursor || 'pointer',
    });
  };

  render() {
    return null;
  }
}

export default withMap(Geometry);



// WEBPACK FOOTER //
// ./src/common/components/BetterMap/Geometry.js